import { useTranslation } from "react-i18next";
import { TbError404 } from "react-icons/tb";
import { useNavigate } from "react-router";

const NotFoundPage = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`notFound.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const navigate = useNavigate();

  return (
    <section className="flex flex-col gap-[10px] py-[100px] items-center justify-start w-full min-h-screen">
      <TbError404 className="text-[150px] text-main-color" />
      <section className="py-[10px] flex flex-col items-center justify-center">
        <p className="font-medium text-2xl text-transaction-text dark:text-base-light-white tracking-tight">
          {i18n("nothingFound")}
        </p>
        <p className="text-transaction-text dark:text-base-light-white text-center">
          {i18n("commonHint1")}
        </p>
        <p className="mt-[15px] text-text-light dark:text-base-light-white text-center">
          {i18n("commonHint2")}
        </p>
        <section className="flex items-center justify-center gap-[10px]">
          <button
            type="button"
            onClick={() => navigate("/casino")}
            className="p-[10px] font-medium rounded-full text-light-white bg-main-color"
          >
            {i18n_common("Slots")}
          </button>
          <button
            type="button"
            onClick={() => navigate("/live-casino")}
            className="p-[10px] font-medium rounded-full text-light-white bg-main-color"
          >
            {i18n_common("Live-Casino")}
          </button>
          <button
            type="button"
            onClick={() => navigate("/sports")}
            className="p-[10px] font-medium rounded-full text-light-white bg-main-color"
          >
            {i18n_common("Sports")}
          </button>

          <button
            type="button"
            onClick={() => navigate("/promotion")}
            className="p-[10px] font-medium rounded-full text-light-white bg-main-color"
          >
            {i18n_common("promotion")}
          </button>
        </section>
      </section>
    </section>
  );
};

export default NotFoundPage;
